import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import Layout from '../../../Layout';
import { Box, Wrapper } from '../../../UI';
import Letter from './Letter';
import Parameters from './Parameters';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import PageTitle from '../../../Layout/PageTitle'
import { Button } from '@material-ui/core';
import NavigateBack from '../../../UI/NavigateBack';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import { Link } from 'react-router-dom';

export default function LoI({ match }) {
	const { height } = useWindowDimensions();
	const innerHeight = height - 94;
	const propertyId = match.params.propertyId;
	const [copy, setCopy] = React.useState({
		letterhead:
			'Saul Hudson, Woodland Hills, California (CA), United States 91364',
		fixed: 'English Law, London Jurisdiction',
		par1:
			'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit animi exercitationem tempora quam ad sapiente?',
		purchasePrice: 180000000,
		conclusion: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit.',
	});

	const handleChange = e => {
		setCopy({
			...copy,
			[e.target.name]: e.target.value,
		});
	};

	const [open, setOpen] = React.useState(false);

	const handleClick = () => {
		setOpen(true);
	};

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		setOpen(false);
	};
	console.log(match.url)

	return (
		<Layout>
			<Wrapper>
				<Box p="30px" height={innerHeight} style={{overflow: 'hidden'}}>
					<PageTitle handleClick={handleClick} title={`Letter of Intent for ${propertyId}`} action={<NavigateBack slug={`/market-search/${propertyId}`} />}>
						<Box display="flex" justifyContent="flex-end">
							<Button variant="contained" color="default" style={{marginRight: '1rem'}} startIcon={<VisibilityIcon />}>
								View
							</Button>
							<Button variant="contained" color="default" style={{marginRight: '1rem'}} startIcon={<EditIcon />}>
								Print
							</Button>
							<Button variant="contained" color="primary" startIcon={<EmailIcon />} component={Link} to={`${match.url}/success`}>
								Send to seller
							</Button>
						</Box>
					</PageTitle>
					<Box display='flex'>
						<Box width="40%">
							<Parameters propertyId={propertyId} copy={copy} setCopy={setCopy} onChange={handleChange} />
						</Box>
						<Box width="60%">
							<Letter copy={copy} propertyId={propertyId} height={innerHeight} />
						</Box>
					</Box>
				</Box>
			</Wrapper>
			<Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
				<Alert onClose={handleClose} severity="success">
					Letter of Intent succefully sent to seller!
				</Alert>
			</Snackbar>
		</Layout>
	);
}
